<template>
	<section id="promotional_tours_" style="padding-bottom: 0px; padding-top: 2rem;">
		<div class="container">
			<div class="row">
				<div class="col-12 mb-3">
					<h5 class="text-coral">{{ capitalize($t("comments")) }}</h5>
				</div>
			</div>

			<div class="row">
				<div class="col-lg-12">

					<form @submit.prevent="submitComment" class="mb-3">
						<div class="mb-2 d-flex align-items-center">
							<div>
								<span v-for="(item, index) in satisfactionEmojis" :key="index" :title="item.label"
									:class="['emoji-face', { selected: selectedSatisfaction === index + 1 }]"
									@click="selectedSatisfaction = index + 1">
									{{ item.emoji }}
								</span>
							</div>
						</div>

						<textarea v-model="newComment" class="form-control mb-2" placeholder="..." rows="2"></textarea>
						<div class="d-flex justify-content-end">
							<button v-if="isAuth" style="background-color: #5d69d5;" class="btn btn-sm save-comment"
								:disabled="loading || !newComment || selectedSatisfaction == null">
								{{ loading ? capitalize($t("sending")) + "..." : capitalize($t('comment')) }}
							</button>
							<button v-else style="background-color: #5d69d5;" class="btn btn-sm save-comment"
								@click="$router.push({ name: 'login' })">
								{{ capitalize($t("login")) }}
							</button>
						</div>
					</form>

					<ul class="list-group mb-3">
						<li v-for="comment in comments" :key="comment.id" class="list-group-item">
							<strong class="ms-2"><span>💬</span> {{ comment.user.name }}</strong>
							<span class="mx-1" :title="satisfactionEmojis[comment.rating - 1]?.label" v-if="comment.rating">{{ satisfactionEmojis[comment.rating - 1]?.emoji }} </span>
							<small><small class="text-muted">{{ formatDate(comment.created_at) }}</small></small>
							<div class="ms-4">{{ comment.body }}</div>
						</li>
						<div v-if="comments.length === 0" class="text-muted list-group-item my-3">{{ $t("no_comments")
						}}</div>
					</ul>


				</div>
			</div>
		</div>
	</section>
</template>

<script>
import axios from 'axios';
import { API_BASE_URL, COMMENTS } from "@/api-config";
import { capitalize } from '@/utils/global';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/es';
import 'dayjs/locale/en';
import { mapState } from 'vuex';
import { trackEvent } from "@/composables/useMetrics";


dayjs.extend(relativeTime);
dayjs.locale(localStorage.getItem("lang") ?? 'es');

const MODEL_TYPE_TO_SUBJECT = Object.freeze({
	place: "commerce",
	ally: "ally",
});



export default {
	name: 'Comments',
	props: {
		modelId: {
			type: [String, Number],
			required: true,
		},
		modelType: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			comments: [],
			newComment: '',
			loading: false,
			selectedSatisfaction: null,
			satisfactionEmojis: [
				{ emoji: '😠', label: 'Muy insatisfecho' },
				{ emoji: '😞', label: 'Insatisfecho' },
				{ emoji: '😐', label: 'Neutral' },
				{ emoji: '🙂', label: 'Satisfecho' },
				{ emoji: '😄', label: 'Muy satisfecho' },
			],

		};
	},
	computed: {
		...mapState('autentication', ['isAuth'])
	},
	methods: {
		capitalize,
		async loadComments() {
			try {
				const { data } = await axios.get(`${API_BASE_URL}${COMMENTS}${this.modelType}/${this.modelId}`);
				this.comments = data.data;
			} catch (error) {
				console.error('Error al cargar comentarios:', error);
			}
		},
		async submitComment() {
			if (!this.newComment.trim() || this.selectedSatisfaction == null) return;
			this.loading = true;
			try {
				const { data } = await axios.post(`${API_BASE_URL}${COMMENTS}${this.modelType}/${this.modelId}`, {
					body: this.newComment,
					rating: this.selectedSatisfaction,
				});
				const createdComment = data.data;
				this.comments.unshift(createdComment);
				this.newComment = '';
				this.selectedSatisfaction = null;
				this.emitCommentMetric(createdComment);
			} catch (error) {
				console.error('Error al enviar comentario:', error);
			} finally {
				this.loading = false;
			}
		},
		emitCommentMetric(createdComment) {
			const subjectType = MODEL_TYPE_TO_SUBJECT[this.modelType];
			if (!subjectType) {
				return;
			}
			const meta = {
				comment_id: createdComment?.id ?? null,
				rating: createdComment?.rating ?? this.selectedSatisfaction ?? null,
				model_type: this.modelType,
				source: 'comments_component',
			};
			trackEvent(subjectType, this.modelId, 'comment_created', meta);
		},
		formatDate(dateStr) {
			const date = dayjs(dateStr);
			return `${date.fromNow()}`;
		},
	},
	watch: {
		modelId: 'loadComments',
		modelType: 'loadComments',
	},
	mounted() {
		this.loadComments();
	},
};
</script>

<style scoped>
:deep(.save-comment) {
	color: #fff;
}
:deep(.save-comment:hover) {
	background-color: rgb(93, 110, 250);
	transform: scale(1.02);
}
.list-group-item {
	border: 1px solid #eee;
	margin-bottom: 10px;
	border-radius: 5px;
	background: #f8f8ff;
}

:deep(.emoji-face) {
	transition: transform 0.2s ease;
	cursor: pointer;
	font-size: 1.3rem;
	margin-right: 5px;
}

:deep(.emoji-face.selected) {
	font-size: 1.5rem !important;
}

:deep(.emoji-face:hover) {
	font-size: 1.35rem !important;
	transition: transform 0.2s ease;
}

:deep(.emoji-face.selected:hover) {
	font-size: 1.5rem !important;
	cursor: text;
}

:deep(.selected) {
	font-size: 1.2rem !important;
}
</style>
